// extracted by mini-css-extract-plugin
module.exports = {"card-item-block":"card-item-block_card-item-block__huE9_","item-rarity":"card-item-block_item-rarity__jyh9B","item":"card-item-block_item__rtSih"};